//@ts-nocheck

import apolloClient from 'apollo-client'
import {mapToUpdateShippingPackageModel} from 'app/features/orders/redux/fulfillment/helper'
import {
  CREATE_SHIPPING_PACKAGES,
  GET_SHIPPING_PACKAGES,
  GET_SHIPPING_PACKAGE,
  UPDATE_SHIPPING_PACKAGES,
  DELETE_SHIPPING_PACKAGE,
  GET_SHIPPING_PACKAGES_LIST,
  GET_SHIPPING_PACKAGE_NAME_AVAILABLE,
  GET_SHIPPING_PACKAGES_WITHOUT_OFFSET,
  GET_ALL_SHIPPING_PACKAGES,
} from './graphql'

import ShippingPackage from 'app/features/orders/models/ShippingPackage'

class ShippingPackageService {
  async list(params) {
    const {data} = await apolloClient.query({
      query: GET_SHIPPING_PACKAGES,
      variables: params,
    })
    return {data: data.shippingPackages.nodes, totalCount: data.shippingPackages.totalCount}
  }

  async all() {
    const {data} = await apolloClient.query({
      query: GET_ALL_SHIPPING_PACKAGES,
    })
    return data.shippingPackages.nodes
  }

  async ShippingList(params: any) {
    if (!params.orderBy) {
      params.orderBy = 'WEIGHT_ASC'
    }
    const {data} = await apolloClient.query({
      query: GET_SHIPPING_PACKAGES_LIST,
      variables: params,
    })
    return {data: data.shippingPackages.nodes, totalCount: data.shippingPackages.totalCount}
  }
  async create(shippingPackage: any) {
    return await apolloClient.mutate({
      mutation: CREATE_SHIPPING_PACKAGES,
      variables: {shippingPackage},
    })
  }
  async update(shippingPackage: ShippingPackage, id: string) {
    return await apolloClient.mutate({
      mutation: UPDATE_SHIPPING_PACKAGES,
      variables: {
        shippingPackage: mapToUpdateShippingPackageModel(shippingPackage, id),
      },
    })
  }
  async delete(id: string) {
    return apolloClient.mutate({
      mutation: DELETE_SHIPPING_PACKAGE,
      variables: {
        id: id,
      },
    })
  }
  async getShippingDetail(id: string) {
    const {data} = await apolloClient.query({
      query: GET_SHIPPING_PACKAGE,
      variables: {
        id: id,
      },
    })
    return data.shippingPackage
  }

  async GetShippingPackageNameAvailable(id: any, name: string) {
    const {data} = await apolloClient.query({
      query: GET_SHIPPING_PACKAGE_NAME_AVAILABLE,
      variables: {
        id: id,
        name: name,
      },
      fetchPolicy: 'network-only',
    })

    return data.shippingPackageNameAvailable
  }

  async getShippingPackages() {
    const {data} = await apolloClient.query({
      query: GET_SHIPPING_PACKAGES_WITHOUT_OFFSET,
    })
    return {data: data.shippingPackages.nodes, totalCount: data.shippingPackages.totalCount}
  }
}

const shippingPackageService = new ShippingPackageService()
export default shippingPackageService
